<template>
  <div
    class="toast"
    :class="colour"
  >
    <span class="fs-6">
      {{ message }}
    </span>

    <FontAwesomeIcon
      :icon="faCircleXmark"
      class="cursor-pointer text-xl"
      @click="$emit('dismissed')"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCircleXmark } from '@fortawesome/pro-light-svg-icons';

const emit = defineEmits(['dismissed']);

const props = defineProps({
  message: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  duration: {
    type: Number,
    default: 5000,
  },
});

const colourMapping = {
  success: 'toast-success',
  info: 'toast-info',
  warning: 'toast-warning',
  danger: 'toast-danger',
};

const colour = computed(() => colourMapping[props.type] || '');

let autoCloseTimer = null;

const startAutoCloseTimer = () => {
  autoCloseTimer = setTimeout(() => {
    emit('dismissed');
  }, props.duration);
};

onMounted(() => {
  startAutoCloseTimer();
});

onBeforeUnmount(() => {
  if (autoCloseTimer) {
    clearTimeout(autoCloseTimer);
  }
});

</script>
